import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

/**
 * Translates the labels of every mat-paginator in the app
 * and refreshes them when the user switches language.
 */
@Injectable()
export class TranslatedPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  private ofLabel = 'of';
  private readonly sub: Subscription;

  constructor(private translate: TranslateService) {
    super();
    this.sub = this.translate.stream([
      'PAGINATOR.ITEMS_PER_PAGE',
      'PAGINATOR.NEXT_PAGE',
      'PAGINATOR.PREVIOUS_PAGE',
      'PAGINATOR.FIRST_PAGE',
      'PAGINATOR.LAST_PAGE',
      'PAGINATOR.OF',
    ]).subscribe((t) => {
      this.itemsPerPageLabel = t['PAGINATOR.ITEMS_PER_PAGE'];
      this.nextPageLabel = t['PAGINATOR.NEXT_PAGE'];
      this.previousPageLabel = t['PAGINATOR.PREVIOUS_PAGE'];
      this.firstPageLabel = t['PAGINATOR.FIRST_PAGE'];
      this.lastPageLabel = t['PAGINATOR.LAST_PAGE'];
      this.ofLabel = t['PAGINATOR.OF'];
      this.changes.next();
    });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.ofLabel} ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return `${startIndex + 1} – ${endIndex} ${this.ofLabel} ${length}`;
  };

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
